var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInvoiceSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99976 2V15H12.9998V5.2998L12.8494 5.15039L9.84937 2.15039L9.69995 2H2.99976ZM3.99976 3H8.99976V6H11.9998V14H3.99976V3ZM9.99976 3.7002L11.2996 5H9.99976V3.7002ZM4.99976 7V8H10.9998V7H4.99976ZM4.99976 9.5V10.5H8.49976V9.5H4.99976ZM9.49976 9.5V10.5H10.9998V9.5H9.49976ZM4.99976 11.5V12.5H8.49976V11.5H4.99976ZM9.49976 11.5V12.5H10.9998V11.5H9.49976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceSolid);
export default __webpack_public_path__ + "static/media/file-invoice-solid.1478772a96ea5de9cfe955e6dd88fa5a.svg";
export { ForwardRef as ReactComponent };